
import React from 'react';
import Icon from './index';

const vectors = 'M19.5774787,5.25585467 C21.4815592,7.15993519 21.5357257,10.229935 19.7,12.2 L12.5916667,19.3166667 C12.4351945,19.4744272 12.2221979,19.5631653 12,19.5631653 C11.7778021,19.5631653 11.5648055,19.4744272 11.4083333,19.3166667 L4.3,12.2 C2.46427426,10.229935 2.51844083,7.15993519 4.42252134,5.25585467 C6.32660185,3.35177416 9.39660164,3.2976076 11.3666667,5.13333333 L12,5.75833333 L12.6333333,5.13333333 C14.6033984,3.2976076 17.6733981,3.35177416 19.5774787,5.25585467 Z';

export default function HeartFill(props) {
  return (
    <Icon {...props} viewBox="0 0 24 24" vectors={vectors} />
  );
}

